import { useReportBannerVisibility, useShouldShowBanner } from '@ms/yammer-hooks/dist/browserDeprecation/';
import React, { ReactNode, Suspense, useCallback } from 'react';

import LoadableBrowserDeprecationMessage from '../BrowserDeprecationMessage';

type UseDeprecationBanner = (suppressDismiss: boolean) => (() => ReactNode) | undefined;
export const useDeprecationBanner: UseDeprecationBanner = (suppressDismiss) => {
  const shouldShowBanner = useShouldShowBanner(suppressDismiss);
  useReportBannerVisibility(shouldShowBanner);
  const learnMoreBrowserUpdate = 'https://go.microsoft.com/fwlink/?linkid=2157861';

  const bannerCallback = useCallback(
    () => (
      <Suspense fallback={null}>
        <LoadableBrowserDeprecationMessage learnMoreHref={learnMoreBrowserUpdate} suppressDismiss={true} />
      </Suspense>
    ),
    []
  );

  return shouldShowBanner ? bannerCallback : undefined;
};
